<template>
  <div>
    <div class="d-flex flex-row-column">
      <headnavigation :flow="flow" />
      <div class="d-inline-block ml-auto r-width-100">
        <md-button
          @click="$router.push('/lmt/agents/'+id+'/edit')"
          class="md-primary md-raised c-primary r-width-100"
        >
          <img src="../../../assets/icons/iconButtonEdit.svg" class="mr-2" alt="block" />
          Edit
        </md-button>
        <md-button @click="blockAgent(id)" class="md-primary md-raised c-primary r-width-100">
          <img src="../../../assets/icons/iconButtonBlock.svg" class="mr-2" alt="block" />
          <template v-if="data.agent && data.agent.deleted_at">Unblock</template>
          <template v-else>Block</template>
        </md-button>
      </div>
    </div>
    <hr />
    <div class="form-section my-3">{{ $t('agent_specific.general_agent_info') }}</div>
    <b-row v-if="data.agent">
      <b-col md="1" class="r-text-center r-mb-20">
        <img class="mt-2" src="../../../assets/icons/iconGeneralAgentInfo.svg" alt="bank" />
      </b-col>
      <b-col md="5">
        <div class="d-flex">
          <div class="gray-text width-200">{{ $t('general.agent_name') }}</div>
          <div class="d-inline-block">
            <print :text="data.agent.name" />
          </div>
        </div>
        <div class="d-flex">
          <div class="gray-text width-200">{{ $t('general.agent_id') }}</div>
          <div class="d-inline-block">
            <print :text="data.agent.agent_id" />
          </div>
        </div>
        <div class="d-flex">
          <div class="gray-text width-200">Status</div>
          <div class="d-inline-block">
            <span v-if="data.agent.status==1">Active</span>
            <span v-else>Inactive</span>
          </div>
        </div>
        <div v-if="is_crypto" class="d-flex">
          <div class="gray-text width-200">{{ $t('agent_specific.business_name') }}</div>
          <div class="d-inline-block">
            <print :text="data.agent.business_name" />
          </div>
        </div>
      </b-col>
      <b-col md="6">
        <div v-if="!is_crypto" class="d-flex">
          <div class="gray-text width-200">Tax ID</div>
          <div class="d-inline-block">
            <print :text="data.agent.tax_id" />
          </div>
        </div>
        <div v-if="is_crypto" class="d-flex">
          <div class="gray-text width-200">{{ $t('agent_specific.serial_number') }}</div>
          <div class="d-inline-block">
            <print :text="data.agent.serial_number" />
          </div>
        </div>
        <div v-if="is_crypto" class="d-flex">
          <div class="gray-text width-200">{{ $t('agent_specific.irs_ein') }}</div>
          <div class="d-inline-block">
            <print :text="data.agent.irs_ein" />
          </div>
        </div>
        <div class="d-flex">
          <div class="gray-text width-200">Start Date</div>
          <div class="d-inline-block">
            <print :text="data.agent.start_date" />
          </div>
        </div>
        <div class="d-flex">
          <div class="gray-text width-200">Termination Date</div>
          <div class="d-flex">
            <print :text="data.agent.termination_date" />
             <span @click="tooltip_d=!tooltip_d" v-if="data.agent.termination_date"  class="ml-2 tooltip-triger">
              <img src="../../../assets/icons/iconInfo.svg" />             
                <tooltip v-if="tooltip_d" :text="data.agent.reasons_for_termination" />
            </span>
          </div>
        </div>
      </b-col>
    </b-row>
    <hr class="my-4" />
    <div class="form-section my-3">{{ $t('agent_specific.agent_location') }}</div>
    <b-row v-if="data.agent">
      <b-col md="1" class="r-text-center r-mb-20">
        <img class="mt-4" src="../../../assets/icons/iconAgentLocation.svg" alt="bcontact" />
      </b-col>
      <b-col md="5">
        <div class="d-flex">
          <div class="gray-text width-200">Street</div>
          <div class="d-inline-block">
            <print :text="data.agent.street" />
          </div>
        </div>
        <div class="d-flex">
          <div class="gray-text width-200">City</div>
          <div class="d-inline-block">
            <print :text="data.agent.city" />
          </div>
        </div>
        <div class="d-flex">
          <div class="gray-text width-200">State</div>
          <div class="d-inline-block">
            <print :text="data.agent.state ? data.agent.state.name : '-'" />
          </div>
        </div>
        <div class="d-flex">
          <div class="gray-text width-200">Zip Code</div>
          <div class="d-inline-block">
            <print :text="data.agent.zip" />
          </div>
        </div>
      </b-col>
      <b-col md="6">
        <img class="img-fluid profile-img" v-if="data.agent.store_image_link" :src="data.agent.store_image_link" alt="agent-img" />
      </b-col>
    </b-row>
    <hr class="my-4" />
    <div class="form-section my-3">Other Info</div>
    <b-row v-if="data.agent">
      <b-col md="1" class="r-text-center r-mb-20">
        <img class="mt-4" src="../../../assets/icons/iconContactInfo.svg" alt="bank" />
      </b-col>
      <b-col md="11">
        <div class="d-flex">
          <div class="gray-text width-50p">Person in Charge</div>
          <div class="d-inline-block">
            <print :text="data.agent.person_in_charge" />
          </div>
        </div>
        <div class="d-flex">
          <div class="gray-text width-50p">Phone Number</div>
          <div class="d-inline-block">
            <print :text="data.agent.phone_number" />
          </div>
        </div>
        <div v-if="!is_crypto" class="d-flex">
          <div class="gray-text width-50p">Fax Number</div>
          <div class="d-inline-block">
            <print :text="data.agent.fax" />
          </div>
        </div>
        <div v-if="!is_crypto" class="d-flex">
          <div class="gray-text width-50p">E-Mail Address</div>
          <div class="d-inline-block">
            <print :text="data.user.email" />
          </div>
        </div>
        <div class="d-flex">
          <div class="gray-text width-50p">License</div>
          <div class="d-inline-block">
            <print :text="data.agent.license" />
          </div>
        </div>
      </b-col>
    </b-row>
    <hr class="my-4" />
    <b-row v-if="data.agent">
      <b-col md="1" class="r-text-center r-mb-20">
        <img class="mt-2" src="../../../assets/icons/iconContactInfo.svg" alt="bank" />
      </b-col>
      <b-col md="11">
        <div class="d-flex">
          <div class="gray-text width-50p">{{ $t('lmt_specific.lmt_have_ownership_in_agents') }}</div>
          <div class="d-inline-block">
            <span v-if="data.agent.ownership_in_agents">Yes</span>
            <span v-else>No</span>
          </div>
        </div>
        <div v-if="!is_crypto" class="d-flex">
          <div class="gray-text width-50p">{{ $t('lmt_specific.is_the_agent_an_lmt') }}</div>
          <div class="d-inline-block">
            <span v-if=" data.agent.is_agent_lmt">Yes</span>
            <span v-else>No</span>
          </div>
        </div>
        <div class="d-flex">
          <div class="gray-text width-50p">{{ $t('lmt_specific.crypto_type') }}</div>
          <div class="d-inline-block">
            <print :text="(this.data.agent.crypto_types.length > 0) ? [].concat(...this.data.agent.crypto_types.map(({label}) => label)).join(', ') : ''" />
          </div>
        </div>
        <div v-if="!is_crypto" class="d-flex">
          <div class="gray-text width-50p">Training Date</div>
          <div class="d-inline-block">
            <print :text="data.agent.training_date" />
          </div>
        </div>
      </b-col>
    </b-row>
    <hr class="my-4" />
    <b-row v-if="data.agent">
      <b-col md="1" class="r-text-center r-mb-20">
        <img class="mt-4" src="../../../assets/icons/iconOtherInfo3.svg" alt="bank" />
      </b-col>
      <b-col md="11">
        <div class="d-flex">
          <div class="gray-text width-50p">Expected Monthly Dollar Volume</div>
          <div class="d-inline-block">
            <print :text="data.agent.exp_mon_dollar_vol ? '$ '+(data.agent.exp_mon_dollar_vol).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') : ''" />
          </div>
        </div>
        <div class="d-flex">
          <div class="gray-text width-50p">Expected Monthly Number of Transactions</div>
          <div class="d-inline-block">
            <print :text="data.agent.exp_mon_transactions ? (data.agent.exp_mon_transactions).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''" />
          </div>
        </div>
        <div class="d-flex">
          <div class="gray-text width-50p">Expected Average Transaction Amount</div>
          <div class="d-inline-block">
            <print :text="data.agent.exp_avg_transaction_amount ? '$ '+(data.agent.exp_avg_transaction_amount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') : ''" />
          </div>
        </div>
        <div v-if="!is_crypto" class="d-flex">
          <div class="gray-text width-50p">{{ $t('agent_specific.countries_agent_will_remit') }}</div>
          <div class="d-inline-block">
            <span
              class="d-inline-block mr-3"
              v-for="(item, index) in data.agent.countries"
              :key="index"
            >{{item.name}}</span>
          </div>
        </div>
      </b-col>
    </b-row>
    <div v-if="!is_crypto">
      <hr class="my-4" />
      <div class="form-section my-3">Renewal Documents</div>
      <renewal-doc
        v-if="data.agent"
        class="fixed-table"
        :data="[{link:data.agent.training_doc_link,doc:data.agent.training_doc,renewal:data.agent.training_date}]"
        text="Training Document"
      />
    </div>
    <div class="form-section my-3">Documents</div>
    <b-row v-if="data.agent">
      <b-col>

        <div class="d-flex">
          <div class="gray-text width-50p">{{ $t('agent_specific.agent_agreement') }}</div>
          <div class="d-inline-block" v-if="data.agent.agent_agreement">
            <a href="javascript:;" @click="downloadFileRequest(data.agent.agent_agreement_link)">{{
              data.agent.agent_agreement
            }}</a>
          </div>
        </div>
      
        <hr class="my-3" />
        <div class="d-flex">
          <div class="gray-text width-50p">{{ $t('agent_specific.incorporation_doc') }}</div>
          <div class="d-inline-block" v-if="data.agent.incorporation_doc">
            <a href="javascript:;" @click="downloadFileRequest(data.agent.incorporation_doc_link)">{{
              data.agent.incorporation_doc
            }}</a>
          </div>
        </div>

        <hr class="my-3" />
        <div class="d-flex">
          <div class="gray-text width-50p">{{ $t('agent_specific.compliance_handbook') }}</div>
          <div class="d-inline-block" v-if="data.agent.compliance_handbook">
            <a href="javascript:;" @click="downloadFileRequest(data.agent.compliance_handbook_link)">{{
              data.agent.compliance_handbook
            }}</a>
          </div>
        </div>

      <div v-if="!is_crypto">
        <hr class="my-3" />
        <div class="d-flex">
          <div class="gray-text width-50p">Compliance Officer Designation</div>
          <div class="d-inline-block" v-if="data.agent.compliance_officer_designation">
            <a href="javascript:;" @click="downloadFileRequest(data.agent.compliance_officer_designation_link)">{{
              data.agent.compliance_officer_designation
            }}</a>
          </div>
        </div>
      </div>

        <hr class="my-3" />
        <div class="d-flex">
          <div class="gray-text width-50p">Business Registration/Certificate of Formation</div>
          <div class="d-inline-block" v-if="data.agent.business_reg_formation_doc">
            <a href="javascript:;" @click="downloadFileRequest(data.agent.business_reg_formation_doc_link)">{{
              data.agent.business_reg_formation_doc
            }}</a>
          </div>
        </div>

      <div v-if="!is_crypto">
        <hr class="my-3" />
        <div class="d-flex">
          <div class="gray-text">Owners IDs</div>
          <div class="d-inline-block" v-if="data.agent.owner_ids">
            <div v-for="(item, index) in data.agent.owner_ids" :key="index">
              <span class="gray-text d-inline-block ml-5 mr-2">{{item.name}}:</span>
              <a href="javascript:;" @click="downloadFileRequest(item.link)">{{
                item.doc
              }}</a>
            </div>
          </div>
        </div>
      </div>

      </b-col>
    </b-row>
    <hr class="my-3" />
  </div>
</template>
<script>
// import CRUD methods for users
import Users from "../../../mixins/lmt/users.js";
import {fileMixin} from '@/mixins/fileMixin';

export default {
  mixins: [Users, fileMixin],

  data() {
    return {
      is_crypto: (process.env.VUE_APP_SYSTEM == "crypto") ? true : false,
      tooltip_d: 0,
      id: this.$route.params.id,
      data: {},
      flow: [{ text: this.$tc('general.store_agent', 2), link: "/lmt/agents" }, { text: "" }]
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
      blockAgent(id) {
            window.axios
                .post("/lmt/agent/block?id=" + id)
                .then(({ data }) => {
                    Event.$emit("message", [data.message]);
                    this.loadData();
                })
        },
    loadData() {
      axios
       .get("/get-agent?id=" + this.id)
        .then(({ data }) => {
          this.data = data;
          this.flow[1].text = data.agent.name;
        })
        .catch(error => {
          //this.$router.push("/owner/agents");
        });
    }
  }
};
</script>